<template>
  <div id="vincode-app">
    <component
      :is="routes[currentPage].component"
      :messages="messages[currentPage]"
      class="page"
      :info="info"
      :win="win"
      :componentData="componentData"
      :refreshDate="refreshDate"
      :formInfoItems="formInfoItems"
      :hint="hint"
      @customEvent="handler($event)"
      @formOpen="handlerOpen($event)"
      @addInfoItems="sendToForm($event)"
      @customWin="handleWin($event)"
      @refresh="handlRefresh($event)"
      />
  </div>
</template>

<script>
import EnterVin from "@/components/EnterVin.vue";
import Result from "@/components/Result.vue";
import ServiceRequest from "@/components/ServiceRequest.vue";
import messages from "./messages.json";
import routes from "@/routes.js";
import seo from "@/mixins/seo";

export default {
  name: "App",

  components: {
    EnterVin,
    Result,
    ServiceRequest
  },

  data() {
    return {
      currentPage: "enter_vin",
      messages,
      info: null,
      routes,
      win: null,
      pages: Object.keys(routes),
      refreshDate: null,
      componentData: null,
      seoObj: null,
      formInfoItems: null,
      hint: null
    };
  },

  mixins: [seo],

  methods: {
    handler(e) {
      if (e.componentName === "result") {
        this.currentPage = "result";
        this.info = e;
      } else {
        this.currentPage = "enter_vin";
        this.info = e;
      }
    },
    handlerOpen(e) {
      if (e === "serviceRequest") {
        this.currentPage = "service_request";
      }
    },
    handleWin(e) {
      this.win = e;
    },
    handlRefresh(data) {
      if (data.componentName === "enterVin") {
        this.currentPage = "enter_vin";
        this.componentData = data;
      }
    },
    sendToForm(e) {
      this.formInfoItems = e.items;
      this.hint = e.hint;
    }
  }
};
</script>

<style>
#vincode-app {
  text-align: center;
  /* margin-top: 60px; */
}
.error-container {
  text-align: center;
}
.page-button {
  padding: 6px 10px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  border: 1px solid #ccc;
  cursor: pointer;
  background: #f0f0f0;
  margin-bottom: -1px;
  margin-right: -1px;
}
.page-button:hover {
  background: #e0e0e0;
}
.page-button.active {
  background: #e0e0e0;
}
.page {
  /* border: 1px solid #ccc; */
  /* padding: 10px; */
}
</style>
